import { ReactComponent as SvgCopy } from '@img/icons/pb-copy.svg';
import { ReactComponent as SvgDelete } from '@img/icons/pb-delete.svg';
import { ReactComponent as SvgMove } from '@img/icons/pb-move.svg';
import { ReactComponent as SvgRename } from '@img/icons/pb-rename.svg';
import { ReactComponent as SvgView } from '@img/icons/pb-view.svg';
import { pinboards } from '@redux/slices/pinboards';
import { DrawerMode } from '@redux/slices/pinboards/types';
import { useAppDispatch, useAppSelector } from '@redux/store';
import Button from '@stories/Components/Button/Button';
import * as React from 'react';
import S from '../PinboardActionDrawer.styles';
const ManagePinboard = (props) => {
    const dispatch = useAppDispatch();
    const items = useAppSelector((state) => state.pinboards.items);
    const itemToManage = items.find((item) => item.id === props.id);
    if (!itemToManage) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement(S.Title, null, itemToManage.title)),
        React.createElement(S.Body, { ref: props.scrollRef },
            React.createElement(S.OptionList, null,
                React.createElement(S.OptionItem, null,
                    React.createElement(S.OptionButton, { as: "a", href: itemToManage.url },
                        React.createElement(S.OptionIcon, { as: SvgView }),
                        "View/Edit Pins")),
                React.createElement(S.OptionItem, null,
                    React.createElement(S.OptionButton, { onClick: (event) => {
                            event.preventDefault();
                            dispatch(pinboards.actions.showDrawer({
                                mode: DrawerMode.RENAME_PINBOARD,
                                data: props.id,
                            }));
                        } },
                        React.createElement(S.OptionIcon, { as: SvgRename }),
                        "Rename board")),
                React.createElement(S.OptionItem, null,
                    React.createElement(S.OptionButton, { disabled: itemToManage.items.length === 0, onClick: (event) => {
                            event.preventDefault();
                            dispatch(pinboards.actions.showDrawer({
                                mode: DrawerMode.MOVE_PINBOARD_ITEMS,
                                data: props.id,
                            }));
                        } },
                        React.createElement(S.OptionIcon, { as: SvgMove }),
                        "Move all pins to another board")),
                React.createElement(S.OptionItem, null,
                    React.createElement(S.OptionButton, { disabled: itemToManage.items.length === 0, onClick: (event) => {
                            event.preventDefault();
                            dispatch(pinboards.actions.showDrawer({
                                mode: DrawerMode.COPY_PINBOARD_ITEMS,
                                data: props.id,
                            }));
                        } },
                        React.createElement(S.OptionIcon, { as: SvgCopy }),
                        "Copy all pins to another board")),
                React.createElement(S.OptionItem, null,
                    React.createElement(S.OptionButton, { onClick: (event) => {
                            event.preventDefault();
                            dispatch(pinboards.actions.showDrawer({
                                mode: DrawerMode.DELETE_PINBOARD,
                                data: props.id,
                            }));
                        } },
                        React.createElement(S.OptionIcon, { as: SvgDelete }),
                        "Delete board")))),
        React.createElement(S.ActionList, null,
            React.createElement(Button, { buttonType: "outline", type: "button", onClick: props.onCancel }, "Cancel"))));
};
export default ManagePinboard;
